import React from 'react';
import ViewUser from '../../components/usermanagement_comp/ViewUser';

/**
 * ViewUserPage — Page wrapper for User Management list module
 */
const ViewUserPage = () => {
    return (
        <div
            className="d-flex flex-column"
            style={{ height: '100vh', padding: '0', boxSizing: 'border-box', overflow: 'hidden' }}
        >
            <ViewUser />
        </div>
    );
};

export default ViewUserPage;
